import createErrors from '../createErrors';
import { type Page } from './constants';

const CHECKOUT_PAGE = 'Checkout';

export type Component = 'AuthorizedSections' | 'DeliveryInstructions';

export const Events = {
    OPEN_DELIVERY_INSTRUCTIONS: {
        page: CHECKOUT_PAGE,
        action: 'OPEN_DELIVERY_INSTRUCTIONS',
    },
    SAVE_DELIVERY_INSTRUCTIONS: {
        page: CHECKOUT_PAGE,
        action: 'SAVE_DELIVERY_INSTRUCTIONS',
    },
};

/**
 * Errors related to the Checkout page
 */
export const Errors = createErrors<Page, Component>(CHECKOUT_PAGE)({
    AuthorizedSections: {
        GetPetsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch pets',
        },
        EditPetFailed: {
            severity: 'MEDIUM',
            message: 'Failed to edit pet',
        },
        SavePrescriptionFailed: {
            severity: 'MEDIUM',
            message: 'Failed to save prescription information',
        },
        AddPetProfileUnavailable: {
            severity: 'MEDIUM',
            message: 'Profile service unavailable while adding a pet, continuing with cart-only pet',
        },
        PersistRegisteredPetIdsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to persist registered pet ids, a reload may offer the same pet twice',
        },
    },
    DeliveryInstructions: {
        SaveDeliveryInstructionsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to save delivery instructions',
        },
    },
});
